/**=========================================================
 * Module: decimals.js
 * Decimal numbers
 =========================================================*/

App.directive("decimals", function ($filter) {
    return {
        restrict: "A", // Only usable as an attribute of another HTML element
        require: "?ngModel",
        scope: {
            decimals: "@",
            decimalpoint: "@"
        },
        link: function (scope, element, attr, ngModel) {
            var decimalCount = parseInt(scope.decimals) || 2;
            if(scope.decimals==='0') decimalCount = 0;
            var decimalPoint = scope.decimalpoint || ".";
            var thousandPoint = decimalPoint=='.' ? ',' : '.';

            var thSep = function(nStr, dSep, thSep)
            {
            	nStr += '';
            	var x = nStr.split(dSep);
            	var x1 = x[0];
            	var x2 = x.length > 1 ? dSep + x[1] : '';
            	var rgx = /(\d+)(\d{3})/;
            	while (rgx.test(x1)) {
            		x1 = x1.replace(rgx, '$1' + thSep + '$2');
            	}
            	return x1 + x2;
            }


            // Run when the model is first rendered and when the model is changed from code
            ngModel.$render = function() {
                if (ngModel.$modelValue != null && ngModel.$modelValue >= 0) {
                    if (typeof decimalCount === "number") {
                    	var s = ngModel.$modelValue.toFixed(decimalCount).toString();
                    	s = s.replace(".", decimalPoint);
                    	s = thSep(s, decimalPoint, thousandPoint);
                        element.val(s);
                    } else {
                    	var s = ngModel.$modelValue.toString();
                    	s = s.replace(".", decimalPoint);
                    	s = thSep(s, decimalPoint, thousandPoint);
                        element.val(s);
                    }
                }
            }

            // Run when the view value changes - after each keypress
            // The returned value is then written to the model
            ngModel.$parsers.unshift(function(newValue) {
            	while(newValue.indexOf(thousandPoint)>=0){
            		newValue = newValue.replace(thousandPoint, '');
            	}
                if (typeof decimalCount === "number") {
                    var floatValue = parseFloat(newValue.replace(decimalPoint, "."));
                    if (decimalCount === 0) {
                        return parseInt(floatValue);
                    }
                    return parseFloat(floatValue.toFixed(decimalCount));
                }

                return parseFloat(newValue.replace(decimalPoint, "."));
            });

            // Formats the displayed value when the input field loses focus
            element.on("change", function(e) {
            	var s = element.val();
            	while(s.indexOf(thousandPoint)>=0){
            		s = s.replace(thousandPoint, '');
            	}
                var floatValue = parseFloat(s.replace(decimalPoint, "."));
                if (!isNaN(floatValue) && typeof decimalCount === "number") {
                    if (decimalCount === 0) {
                        element.val(thSep(parseInt(floatValue),decimalPoint, thousandPoint));
                    } else {
                        var strValue = floatValue.toFixed(decimalCount);
                        strValue = strValue.replace(".", decimalPoint);
                        element.val(thSep(strValue, decimalPoint, thousandPoint));
                    }
                }
            });
        }
    }
});
